<template>
  <div class="main">
    <!-- Панель управления авто -->
    <div id="СontrolPanel" v-bind:class="{ 'panel-hide' : hidePanel }">
      <div class="panel-cnt">
        <!-- Верхняя линия -->
        <div class="top-line">
          <div class="user-menu_button" v-on:click="toogleUserMenu">
            <img src="../assets/img/menu/close_white.svg" v-if="typeOptionPanel === 1">
            <img src="../assets/img/menu/burger.svg" v-else>
          </div>
          <img src="../assets/img/mft_logo.svg" class="top-line_logo" v-on:click="toggleInitialPage">
          <div class="toggle-Controlpanel"
               v-bind:class="{ 'active' : hidePanel }"
               v-on:click="hidePanel = !hidePanel">
            <img src="../assets/img/menu/2-chevron-w.svg">
          </div>
        </div>
        <!-- Список Машин -->
        <perfect-scrollbar ref="CarListScroll">
          <CarList v-if="stateControlPanel === 1">
          </CarList>
        </perfect-scrollbar>
        <UserMenu v-if="stateControlPanel === 0">
        </UserMenu>
      </div>
    </div>
    <!-- Карты -->
    <div class="main-bg">
			<transition name="fade" mode="out-in">
				<Gmap v-if="typeMap === 1">
				</Gmap>
				<OSM v-if="typeMap === 0">
				</OSM>
			</transition>
      <div class="autorize">
      </div>
    </div>
    <!-- Опционная панель -->
    <OptionPanel v-if="statusOptionPanel">
    </OptionPanel>

		<!-- Global Preloader -->
		<transition name="fade">
			<div class="preloader"
					 v-if="globalPreloader">
			</div>
		</transition>


    <transition name="fade">
      <div class="app-popup" v-if="popup.active" @click="missPopup($event)">
        <div class="app-popup_cnt">
          <div class="s-title">Подтверждение:</div>
          <p>
            Вы действительно хотите удалить аккаунт <b class="s-title">{{user.data.email}}</b>?
          </p>
          <div class="app-popup_btns">
            <div class="btn btn-cancel" @click="togglePopup">Нет</div>
            <div class="btn btn-success" @click="delAccount">Да</div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import Gmap         from  './Gmap'
  import OSM          from  './OSM'
  import CarList      from  './CarList'
  import UserMenu     from  './UserMenu'
  import OptionPanel  from  './OptionPanel'

  import { HTTP_AUTH } from '@/main'

  export default {
    data : function () {
      return{
        remind : '',
        hidePanel : false,
      }
    },
    methods : {
      toogleUserMenu : function () {
        if( this.statusOptionPanel === 0 ){
          this.$store.dispatch('controlPanel', 0 );
          this.$store.dispatch('optionPanel', 1);
          this.$store.dispatch('optionPanelType', 1);
        }else{
          if( this.typeOptionPanel === 1 ){
            this.$store.dispatch('controlPanel', 1 );
            this.$store.dispatch('optionPanel', 0);
            this.$store.dispatch('optionPanelType', 0);
          }else{
            this.$store.dispatch('controlPanel', 0 );
            this.$store.dispatch('optionPanel', 1);
            this.$store.dispatch('optionPanelType', 1);
          }
        }
      },
      toggleInitialPage : function() {
        this.$store.dispatch('toggleInitialPage');
      },
      delAccount : function (){
        this.togglePopup();
        this.$store.dispatch('globalPreloader');

        HTTP_AUTH.delete( '/user/delete/' ).then( () => {
          this.$store.dispatch( 'addAlert', {
            text : 'Аккаунт удален',
            type : 'success'
          });
          document.cookie = 'userToken=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';

          setTimeout( () => {
            window.location.reload();
          }, 3000);
        }).catch( error => {
          this.$store.dispatch('errorResponse', error );
        });
      },
      togglePopup : function (){
        this.$store.dispatch('mainPopup');
      },
      missPopup : function (event){
        if( !event.target.closest('.app-popup_cnt') ){
           this.togglePopup();
        }
      }
    },
    computed : {
      // user
      user : function(){
        return this.$store.state.user
      },
      // Cars
      currentCar : function(){
        return this.$store.state.cars.current;
      },
      listCar(){
        return this.$store.state.cars.list;
      },
      // Panels
      stateControlPanel : function () {
        return this.$store.state.panels.control
      },
      statusOptionPanel : function () {
        return this.$store.state.panels.option.status
      },
      typeOptionPanel : function () {
        return this.$store.state.panels.option.type
      },
      typeMap : function () {
        return this.$store.state.map.type
      },

			// preloader
			globalPreloader : function () {
				return this.$store.state.preloaders.global
      },
      popup : function (){
        return this.$store.state.popup
      }
    },
    watch : {
      'currentCar' : function () {
        setTimeout(()=>{
          if( document.getElementsByClassName('list-cars_item active')[0] && document.getElementsByClassName('ps ps--active-y')[0] ){
            document.getElementsByClassName('ps ps--active-y')[0].scrollTop = document.getElementsByClassName('list-cars_item active')[0].offsetTop
          }
          if( document.getElementsByClassName('list-cars_item__mark')[0] ){
            document.getElementsByClassName('ps ps--active-y')[0].scrollTop = document.getElementsByClassName('list-cars_item__mark')[0].offsetTop
          }
        }, 300);

      }
    },
    components : {
      Gmap,
      OSM,
      CarList,
      OptionPanel,
      UserMenu
    }
  }
</script>